import HubEdito from './HubEdito';
import IpidTemplate from './Ipid';
import Pager from './Pager';
import PriipsTemplate from './Priips';

const functionDictionnary = {
    HubEdito,
    IpidTemplate,
    Pager,
    PriipsTemplate
};

// eslint-disable-next-line import/prefer-default-export
export const getTemplate = masterType => new functionDictionnary[masterType]();
